import { Fragment, useEffect, useRef, useState } from "react"
import styled from 'styled-components';
import Drawer from '@material-ui/core/Drawer';
import { Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getInvoiceDetails } from "../../../api/billingApi";
import './InvoiceDetails.css';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { PDFDocument } from 'pdf-lib';
import LoadingSkeleton from "../../Common/LoadingSkeleton";


const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E5E8EF;
    margin-left: 10px;
    margin-right: 10px;
`;

const Wrapper = styled.div`
    // margin: 10px;
    max-width: 100%;
    width: 700px;
`;

const InvoiceDetails = (props) => {
    const [componentLoading, setComponentLoading] = useState(true);

    const [details, setDetails] = useState(null);

    const componentRef = useRef(null);

    useEffect(() => {
        if (props.data) {
            getInvoiceDetails({
                "form_data": {
                    invoiceId: props.data.id
                }
            })
                .then(response => {
                    setDetails(response.data.data);
                }).finally(() => {
                    setComponentLoading(false);
                })
        }
    }, [props.data])

    const toggle = () => {
        props.hideModal();
    }

    const handleDownloadPdf = async (e) => {
        e.preventDefault();
        const pdfName = `invoice_${details.invoiceData.invoice_id}`;

        const canvas = await html2canvas(componentRef.current, {
            scale: 2,
            useCORS: true,
            scrollY: -window.scrollY
        });

        const imgData = canvas.toDataURL("image/png");

        // A4 dimensions in points
        const a4Width = 595.28;
        const a4Height = 700.89;

        const pdfDoc = await PDFDocument.create();
        const page = pdfDoc.addPage([a4Width, a4Height]);

        const pngImage = await pdfDoc.embedPng(imgData);

        // Calculate dimensions to fit A4 while maintaining aspect ratio
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        let width, height;
        if (imgWidth / imgHeight > a4Width / a4Height) {
            width = a4Width;
            height = (imgHeight * a4Width) / imgWidth;
        } else {
            height = a4Height;
            width = (imgWidth * a4Height) / imgHeight;
        }

        page.drawImage(pngImage, {
            x: (a4Width - width) / 2, // center horizontally
            y: (a4Height - height) / 2, // center vertically
            width: width,
            height: height,
        });

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = pdfName;
        a.click();

        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        const handleResize = () => {
            if (componentRef.current) {
                const { current } = componentRef;
                current.style.width = "595.28pt";
                current.style.height = "auto";
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    let invoiceCreatedAt = '';

    if (details !== null && details.invoiceData !== undefined && details.invoiceData !== null && details.invoiceData.created_at !== undefined && details.invoiceData.created_at !== null)
        invoiceCreatedAt = moment(details.invoiceData.created_at).format('MM-DD-YYYY');

    return (
        <Fragment>
            <Drawer anchor={'right'} open={true} onClose={toggle} >
                <Wrapper className={"manage-tag-modal create-collaborate-modal add_list_modal"}>
                    <Grid container className="invoice-details">
                        <Grid item xs={12}>
                            <Header>
                                <h5>{props.title}</h5>
                                <div class="modal-close cross-icon d-flex justify-content-center align-items-center" onClick={toggle}>
                                    <CloseIcon />
                                </div>
                            </Header>
                            <Grid item xs={12} className={"p-4"}>
                                {
                                    componentLoading || !details ? (
                                        <div>
                                            <LoadingSkeleton />
                                        </div>
                                    ) : (
                                        <>
                                            <div class="usage_info_container">
                                                <div class="row mt-4">
                                                    <div class="col s12">
                                                        <div class="px-3 white radius-10 usage_info_header d-flex justify-content-between align-items-center mt-2">
                                                            <p class="text-dark-blue heading-5 m-0">Transaction details</p>
                                                            <button onClick={handleDownloadPdf} style={{cursor:'pointer'}} class="download__pdf__btn white-text accent--bg--color radius-5 d-inline-flex justify-content-center align-items-center">
                                                                <svg class="mr-2" width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0)">
                                                                        <path d="M9.41333 16.9226C9.41349 16.9227 9.41364 16.9229 9.4138 16.923C9.43306 16.9422 9.45333 16.9605 9.47439 16.9778C9.48403 16.9857 9.49423 16.9926 9.50415 17C9.51599 17.0089 9.52759 17.0181 9.53989 17.0263C9.55177 17.0343 9.56407 17.0411 9.57626 17.0484C9.58743 17.0551 9.59833 17.0621 9.60982 17.0682C9.62224 17.0748 9.63501 17.0805 9.64771 17.0864C9.65966 17.0921 9.67146 17.0981 9.68372 17.1032C9.69603 17.1082 9.70861 17.1124 9.72111 17.1168C9.73427 17.1216 9.74724 17.1266 9.76068 17.1307C9.77318 17.1345 9.78587 17.1372 9.79853 17.1404C9.81224 17.1439 9.82579 17.1477 9.83978 17.1505C9.85443 17.1534 9.86919 17.1551 9.88392 17.1572C9.89607 17.1589 9.90806 17.1613 9.92036 17.1625C9.97505 17.1679 10.0302 17.1679 10.0849 17.1625C10.0972 17.1613 10.1092 17.1589 10.1213 17.1572C10.136 17.1551 10.1508 17.1534 10.1654 17.1505C10.1794 17.1477 10.193 17.1439 10.2067 17.1404C10.2193 17.1372 10.232 17.1345 10.2445 17.1307C10.258 17.1266 10.271 17.1216 10.2841 17.1168C10.2966 17.1123 10.3092 17.1082 10.3215 17.1032C10.3338 17.0981 10.3456 17.0921 10.3575 17.0864C10.3702 17.0805 10.383 17.0748 10.3954 17.0682C10.4069 17.0621 10.4178 17.055 10.429 17.0484C10.4411 17.0411 10.4534 17.0343 10.4653 17.0263C10.4776 17.0181 10.4892 17.0089 10.5011 17C10.511 16.9926 10.5212 16.9857 10.5308 16.9778C10.5519 16.9605 10.5722 16.9423 10.5914 16.923C10.5916 16.9229 10.5917 16.9227 10.5919 16.9226L16.4252 11.0893C16.7506 10.7638 16.7506 10.2362 16.4252 9.91074C16.0998 9.58531 15.5721 9.58531 15.2467 9.91074L10.8359 14.3215V1.33332C10.8359 0.873086 10.4628 0.5 10.0026 0.5C9.54236 0.5 9.16927 0.873086 9.16927 1.33332V14.3215L4.75853 9.91074C4.4331 9.58531 3.90544 9.58531 3.58001 9.91074C3.25458 10.2362 3.25458 10.7638 3.58001 11.0893L9.41333 16.9226Z" fill="white"></path>
                                                                        <path d="M15.8359 18.8359H4.16926C3.70902 18.8359 3.33594 19.209 3.33594 19.6693C3.33594 20.1295 3.70902 20.5026 4.16926 20.5026H15.8359C16.2962 20.5026 16.6693 20.1295 16.6693 19.6693C16.6693 19.2091 16.2961 18.8359 15.8359 18.8359Z" fill="white"></path>
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0">
                                                                            <rect width="20" height="20" fill="white" transform="translate(0 0.5)"></rect>
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>

                                                                Download as pdf
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" ref={componentRef} id={'jsx-template'}>
                                                    <div class="col s12">
                                                        <div class="white radius-10 p-3 margin-tab">
                                                            <div class="d-flex justify-content-between mt-1">
                                                                <div class="">
                                                                    <p class="text-dark-blue heading-4 mb-3">Invoice</p>
                                                                    <p class="text-dark-blue subtitle-1">INVOICE TO : {details.user.full_name}</p>
                                                                    <p class="text-dark-blue subtitle-1">Phone : {details.user.phone}</p>
                                                                </div>
                                                                <div>
                                                                    <div class="d-flex align-items-center mb-3">
                                                                        <p class="text-dark-blue logo-text ml-3">{details.agency.name}</p>
                                                                    </div>
                                                                    <p class="text-dark-blue-65 subtitle-1">INVOICE NO : {details.invoiceData.invoice_id}</p>
                                                                    <p class="text-dark-blue-65 subtitle-1">DATE : {invoiceCreatedAt}</p>
                                                                </div>
                                                            </div>
                                                            <table class="invoice__table">
                                                                <thead>
                                                                    <tr class="py-3">
                                                                        <td class="pl-3 col s3 py-3">
                                                                            <p class="text-gray subtitle-1">Invoice For</p>
                                                                        </td>
                                                                        <td class="col s3 py-3">
                                                                            <p class="text-gray subtitle-1  text-center">Package Type</p>
                                                                        </td>
                                                                        <td class="col s3 py-3">
                                                                            <p class="text-gray subtitle-1  text-center">USD Amount</p>
                                                                        </td>
                                                                        <td class="col s3 py-3">
                                                                            <p class="text-gray subtitle-1  text-center">Amount</p>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td class="pl-3 col s3 py-3">
                                                                            <p class="text-dark-blue-65 subtitle-1">{details.invoiceData.package_name}</p>
                                                                        </td>
                                                                        <td class="col s3 py-3">
                                                                            <p class="text-dark-blue-65 subtitle-1 text-center">{details.invoiceData.package_type === 1 ? 'Regular Package' : (details.invoiceData.package_type === 3 ? 'No Pack' : '')}</p>
                                                                        </td>
                                                                        <td class="col s3 py-3">
                                                                            <p class="text-dark-blue-65 heading-6 text-center">{details.invoiceData.credit_amount}</p>
                                                                        </td>
                                                                        <td class="col s3 py-3">
                                                                            <p class="text-dark-blue-65 heading-6 text-center">${details.invoiceData.price}</p>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <div class="d-flex justify-content-between">
                                                                <div class="text-dark-blue subtitle-1">
                                                                    <p>Payment Info</p>
                                                                    <p class="pt-1">Accounts : {details.user.full_name}</p>
                                                                    <p class="pt-1">Card Number : **** **** **** {details.cardInfo.card_number}</p>
                                                                </div>
                                                                <div class="text-right">
                                                                    <p class="text-dark-blue subtitle-1 weight-semi-bold pt-1">Total : <span class="heading-5">$ {details.invoiceData.price}</span></p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Wrapper>
            </Drawer>
        </Fragment>
    )
}

export default InvoiceDetails;